import React from 'react';
import MainDashboard from './MainDashboard';
import { renderComponent } from 'utils/commonUtils';

const Dashboard = () => {
  return renderComponent(<MainDashboard />);
};

export default Dashboard;
